'use strict';

/*global app*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/
/*global resSuccess*/
/*global resError*/

function DeliveryNoteService() {
  this.$container = $('body');

  this.init();
}

DeliveryNoteService.prototype = $.extend({}, {
  constructor: 'DeliveryNoteService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  findDeliveryNote: function findDeliveryNote(EAN, callback) {
    var _this = this;

    blockElement(_this.$container);
    app.getFormation('delivery_note:find', { EAN: EAN }, function (res) {
      unBlockElement(_this.$container);
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, resSuccess, res.data);
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

